import _ from 'lodash';

export const snakeCase = value => value && value.replace(/([A-Z0-9])/g, x => `_${x.toLowerCase()}`)
  .replace(/\[_/, '[');


export const camelCase = value => value && value.replace(/_([a-z0-9])/g, (x, y) => y.toUpperCase());

const EMPTY_KEYS = new Set();

const deepHashConvert = (obj, func, preservedKeys = EMPTY_KEYS) => {
  if (_.isArray(obj)) {
    return _.map(obj, element => deepHashConvert(element, func, preservedKeys));
  }

  if (!_.isPlainObject(obj)) {
    return obj;
  }

  const output = {};
  _.each(obj, (value, key) => {
    const convertedKey = preservedKeys.has(key) ? key : func(key);
    output[convertedKey] = deepHashConvert(value, func, preservedKeys);
  });
  return output;
};

export const deepHashSnakeCase = obj => deepHashConvert(obj, snakeCase);

export const deepHashCamelCase = (obj, preservedKeys = EMPTY_KEYS) => deepHashConvert(obj, camelCase, preservedKeys);

export const deepHashCamelCaseValues = obj => _.mapValues(obj, value => deepHashCamelCase(value));
